module.exports = __webpack_public_path__ + "img/islington_b4.ef34eed3.jpg";